import React, { useState } from 'react';
import { usePokerGame } from '../context/PokerGameContext';

export const Controller = () => {
  const { addAction, currentAction } = usePokerGame();
  const [raiseAmount, setRaiseAmount] = useState('');

  const handleAction = (action, amount = 0) => {
    let raiseIndex = currentAction.raiseIndex;
    const actionPayload = { action, position: currentAction.playerToAct, raiseIndex };

    if (action === 'bet' || action === 'raise') {
      actionPayload.raiseIndex++;
      actionPayload.amount = amount;
    } else if (action === 'call') {
      actionPayload.amount = currentAction.amountToCall;
    }
    
    console.log('Add action', action, 'on street', currentAction.street);
    addAction(actionPayload);
  };

  return (
    <div className="controller-active">
      <div className="controller-header">
        <h3 className="controller-title">
          <span className="controller-title-dot"></span>
          Action Controller (stub)
        </h3>
        <div className="controller-info-box">
          <p>Street: {currentAction.street}</p>
          <p>Player: {currentAction.playerToAct}</p>
          <p>Pot: {currentAction.potSize}</p>
          <p>To Call: {currentAction.amountToCall}</p>
          <p>Raise Index: {currentAction.raiseIndex}</p>
        </div>
      </div>

      <div className="controller-actions">
        {currentAction.validActions.includes('fold') && (
          <button onClick={() => handleAction('fold')} className="btn-fold">
            Fold
          </button>
        )}
        {currentAction.validActions.includes('check') && (
          <button onClick={() => handleAction('check')} className="btn-check">
            Check
          </button>
        )}
        {currentAction.validActions.includes('call') && (
          <button onClick={() => handleAction('call')} className="btn-call">
            Call
          </button>
        )}
        {currentAction.validActions.includes('raise') && (
          <div className="raise-container">
            <button
              onClick={() => handleAction(currentAction.amountToCall > 0 ? 'raise' : 'bet', parseFloat(raiseAmount))}
              className="btn-raise"
            >
              {currentAction.amountToCall > 0 ? 'Raise' : 'Bet'}
            </button>
            <input
              type="number"
              value={raiseAmount}
              placeholder="amount"
              onChange={(e) => setRaiseAmount(e.target.value)}
              className="raise-input"
            />
          </div>
        )}
      </div>
    </div>
  );
};
